import {Component, Input, OnInit} from '@angular/core';
import {V3ExerciseSessionQuestionBase, V3Jumble} from "../../../model/v3/cspa";

@Component({
    selector: 'app-jumble-result',
    templateUrl: './jumble-result.component.html',
    styleUrls: ['./jumble-result.component.scss'],
    standalone: false
})
export class JumbleResultComponent implements OnInit {
  @Input() questions: V3ExerciseSessionQuestionBase<V3Jumble>[]

  constructor() { }

  ngOnInit(): void {
  }

  getQuestion(q: V3ExerciseSessionQuestionBase<V3Jumble>) {
    return q.questionDef.question.replace(/{\d}/g, "...")
  }

  getStudentAnswer(q: V3ExerciseSessionQuestionBase<V3Jumble>) {
    return q.questionDef.answerDef.answerHolder?.answer?.map(a => a.val.join("; ")) || "-"
  }

  getCorrectAnswer(q: V3ExerciseSessionQuestionBase<V3Jumble>) {
    return q.questionDef.answerDef.answer.map(a => a.val.join(", ")).join("; ")
  }

  isAnswerIncorrect(q: V3ExerciseSessionQuestionBase<V3Jumble>) {
    return q.score == 0 && !!q.questionDef.answerDef.answerHolder
  }
}
